import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ShareButton from './share-button';
import NBCBookmark from '../unified-bookmark';

/**
 * Share Buttons
 */

type ShareButtonsProps = {
  title: string,
  href: string,
  noid: string,
  isVideo?: boolean,
  fastEnabled?: boolean,
  fromLive?: boolean,
};

const {
  nbc: {
    identityActive,
  },
} = window;

export default function ShareButtons({ title, href, noid, isVideo, fastEnabled, fromLive }: ShareButtonsProps) {
  return (
    <div className={`share-buttons ${identityActive && ! fastEnabled && ! fromLive ? 'share-buttons__withBookmark' : ''}`}>
      {
        <Fragment>
          {identityActive && ! fastEnabled && ! fromLive &&
            <div className="identity-profile__video-bookmark">
              <NBCBookmark noid={noid} isVideo={isVideo} />
            </div>
          }
          <ShareButton
            serviceName="facebook"
            className="icon icon-facebook-f"
            href={`https://www.facebook.com/sharer/sharer.php?u=${href}`}
          />
          {/* <ShareButton
            serviceName="twitter"
            className="icon icon-twitter"
            href={`https://twitter.com/intent/tweet?url=${href}`}
          /> */}
          <ShareButton
            serviceName="email"
            className="icon icon-envelope"
            href={`mailto:?body=${title} ${href}`}
          />
        </Fragment>
      }
    </div>
  );
}

ShareButtons.defaultProps = {
  isVideo: false,
  fastEnabled: false,
  fromLive: false,
};

ShareButtons.propTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  noid: PropTypes.string.isRequired,
  isVideo: PropTypes.bool,
  fastEnabled: PropTypes.bool,
  fromLive: PropTypes.bool,
};
